import { useAppDispatch } from '@/store';
import { useEffect, useEffectEvent, useMemo } from 'react';
import { RestTypes, useJbpQuery } from './useJbpQuery';
import { StandingDataResponse, setStandingData } from '@/reducers/standingDataSlice';

const refetchTime = 120 * 60 * 1000; //Refetch after 2 hours (120 minutes)

// Hook for JBP Standing Data - fetched on app load and covers: bookingReasons, cancellationReasons, serviceLines, promiseSets, timeBands, dnoBnoDropdowns, siteTypes
export const useStandingData = () => {
  const dispatch = useAppDispatch();

  const {
    data: standingData,
    isLoading,
    isError
  } = useJbpQuery<StandingDataResponse, StandingDataResponse>(RestTypes.Get, undefined, ['standing-data'], 'jbp/standingData', true, '', undefined, undefined, refetchTime, refetchTime);

  const updateStandingDataSlice = useEffectEvent((standingData: StandingDataResponse) => {
    console.log(`Standing data response received`);
    dispatch(setStandingData(standingData));
  });

  useEffect(() => {
    if (standingData) {
      updateStandingDataSlice(standingData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [standingData]);

  const hasData = useMemo(() => !!standingData, [standingData]);

  return {
    isStandingDataLoading: isLoading,
    hasStandingData: hasData,
    standingDataError: isError
  };
};
